// The quickbar is the sticky element on the school pages with application link

window.addEventListener('DOMContentLoaded', () => {
    const quickbar = document.querySelector('.quickbar');
    if (window.sessionStorage.filters) {
        const resultLink = document.getElementById('result-link');
        if (resultLink) {
            resultLink.style.display = 'block';
        }
    }
    if (quickbar) {
        const topBtn = document.querySelector('[data-apply-top]'); // the quickbar appears when this element leaves the viewport
        if (!topBtn) {
            return;
        }
        const topBtnPos = topBtn.getBoundingClientRect();
        const quickbarOffsetY = topBtnPos.top + topBtnPos.height + window.scrollY;
        const footerHeight = document.querySelector('.footer__wrapper').getBoundingClientRect().height;

        const checkQuickbar = () => {
            const isOpen = quickbar.classList.contains('quickbar--open');
            const y = window.scrollY;
            if (y > quickbarOffsetY) {
                const cHeight = document.body.scrollHeight;
                if ((y + window.innerHeight) > (cHeight - footerHeight)) {
                    quickbar.classList.remove('quickbar--open');
                } 
                else if (!isOpen) {
                    quickbar.classList.add('quickbar--open');
                }
            }
            else if (isOpen) {
                quickbar.classList.remove('quickbar--open');
            }
        };

        window.addEventListener('scroll', checkQuickbar);
        checkQuickbar();
    }

});